export const compare = (a: number | string, b: number | string) => (a < b ? -1 : a > b ? 1 : 0);
